import { render, staticRenderFns } from "./ModalLeave.vue?vue&type=template&id=c226ce5e&scoped=true"
import script from "./ModalLeave.vue?vue&type=script&lang=js"
export * from "./ModalLeave.vue?vue&type=script&lang=js"
import style0 from "./ModalLeave.vue?vue&type=style&index=0&id=c226ce5e&prod&lang=scss&scoped=true"
import style1 from "./ModalLeave.vue?vue&type=style&index=1&id=c226ce5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c226ce5e",
  null
  
)

export default component.exports